import React from 'react';
import { DateUtil, Flashy } from '@axiom/ui';

import type { ChatMetaEntry } from '../../types/chat.types';

const RUN_TIME_MESSAGES = [
  'Brewed',
  'Buzzed',
  'Churned',
  'Cogitated',
  'Cooked',
  'Deliberated',
  'Hummed',
  'Mulled',
  'Noodled',
  'Percolated',
  'Pondered',
  'Puzzled',
  'Ruminated',
  'Sifted',
  'Simmered',
  'Sparked',
  'Tinkered',
  'Whirred',
] as const;

/**
 * `Math.random()` in a render body would re-roll the line on every re-render of
 * the log. Seeding off the id needs no `useMemo` to hold it and survives a
 * remount, because the id is fixed for the life of the entry.
 */
const messageFor = ({ id }: { id: string }) => {
  const seed = [...id].reduce(
    (total, char) => total + (char.codePointAt(0) ?? 0),
    0
  );

  return (
    RUN_TIME_MESSAGES[seed % RUN_TIME_MESSAGES.length] ?? RUN_TIME_MESSAGES[0]
  );
};

export type ChatMetaDataProps = {
  entry: ChatMetaEntry;
};

export const ChatMetaData = ({ entry }: ChatMetaDataProps) => {
  return (
    <Flashy color="textSubtle" name={`CHAT_META_DATA_${entry.id}`}>
      {`${messageFor({ id: entry.id })} for ${DateUtil.displayDuration(
        entry.runTimeMs
      )}`}
    </Flashy>
  );
};
